import type { ReactNode } from "react"

/**
 * The two marks that stand for the two intents, at whatever size the caller
 * needs: a bin for Delete, a lidded box for Archive.
 *
 * Shared because they appear twice over — 20px in the dialog's header, 14px
 * beside the control that opens it — and a control whose icon does not match the
 * dialog it summons is worse than no icon at all.
 */
/**
 * The size an Archive or Delete control renders its mark at, everywhere.
 *
 * One size rather than a dense and a roomy one: they were two pixels apart,
 * which is not a distinction anyone reads — only one more thing to pick wrong.
 */
export const ACTION_GLYPH = 16

export function BinGlyph({ size = 20 }: { size?: number }) {
  return (
    <Frame size={size}>
      <path d="M3.5 5.5h13M8 5.5V4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1.5" />
      <path d="M5 5.5 5.7 16a1 1 0 0 0 1 .9h6.6a1 1 0 0 0 1-.9L15 5.5" />
      <path d="M8.5 8.5v5M11.5 8.5v5" />
    </Frame>
  )
}

export function BoxGlyph({ size = 20 }: { size?: number }) {
  return (
    <Frame size={size}>
      <path d="M3 4.5h14v3H3z" />
      <path d="M4.3 7.5v8a1 1 0 0 0 1 1h9.4a1 1 0 0 0 1-1v-8" />
      <path d="M8.2 10.5h3.6" />
    </Frame>
  )
}

function Frame({ size, children }: { size: number; children: ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  )
}
